import { Route, Routes } from "react-router-dom";
import DepositReportsPage from ".";

export default function DepositReportsRoutes() {
  return (
    <Routes>
      <Route path="/" element={<DepositReportsPage />} />
    </Routes>
  );
}
